import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import { FormDateInput } from '..'
import { DateFilterDef } from './types'

const DateContainer = styled.div`
  padding: 0;
  display: flex;
  gap: 10px;
`

function DateFilter({
  filterDef,
  onChange,
}: {
  filterDef: DateFilterDef
  onChange?: () => void
}) {
  const { control } = useFormContext()

  return (
    <DateContainer>
      <Controller
        name={filterDef.key}
        control={control}
        render={({ field }) => {
          return (
            <FormDateInput
              mode='single'
              inline={true}
              input={false}
              value={field.value}
              onChange={(val?: string | null) => {
                field.onChange(val)

                if (onChange) onChange()
              }}
            />
          )
        }}
      />
    </DateContainer>
  )
}

export default DateFilter
